import { ReactComponent as DownloadLogsIcon } from "@common/assets/images/shared-icons/download-icon.svg";
import Button from "@common/components/Button/Button";
import { NavItem } from "@common/components/Navigation/Navigation.styles";
import { vars } from "@common/styles";
import styled, { css } from "styled-components";

export const Toolbar = styled.div`
  padding-left: 2.8rem;
  padding-right: 2.8rem;
  display: flex;
  flex-direction: row;
`;

export const NewTicketButton = styled(Button)`
  font-size: 1.6rem;
  font-weight: 500;
  padding: 1rem;

  path {
    stroke: ${vars.colors.pureWhite};
  }
`;

export const NavigationTitle = styled(NavItem)<{ $isButton?: boolean }>`
  p {
    color: ${vars.colors.grey10};
    font-weight: normal;
  }

  div {
    display: flex;
    align-items: center;
    height: 100%;

    p {
      max-width: 19rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      user-select: none;

      padding-left: 0.8rem;
      padding-right: 0.8rem;
      font-weight: normal;
    }

    ${(props) =>
      props.$isButton &&
      css`
        &:hover {
          background-color: ${vars.colors.grey100};
          border-radius: 1rem;
        }
      `}
  }
`;

export const DownloadIcon = styled(DownloadLogsIcon)`
  margin-left: 1rem;
  cursor: pointer;
  margin-right: 0.2rem;

  ${(props) =>
    props.$disabled &&
    css`
      cursor: not-allowed;
      svg {
        path: ${vars.colors.grey70};
      }
    `}
`;

export const NavbarNavigation = styled.div`
  border-radius: 50%;
  border: 1px solid ${vars.colors.grey80}; /* Grey border */
  background-color: ${vars.colors.grey100};
  margin-right: 1rem;
  width: 3rem !important;
  height: 3rem !important;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(180deg);
  cursor: pointer;
`;
